import { SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const usePulseConfigSetting = () => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const pulseConfigSetting = getSettingOrDefinitionValue({
    name: SettingValues.PULSE_CONFIG
  });
  const kanbanLimit = pulseConfigSetting?.kanban_limit ?? 100;

  return {
    kanbanLimit
  };
};

export default usePulseConfigSetting;
